import { useEffect, useRef } from 'react';

/**
 * Runs an effect at most once per delay window as its dependencies change. Fires immediately on the first pass and then arms the window, otherwise clearing and restarting the timer so only the last change inside the window runs.
 *
 * @param fnc - Effect body to run.
 * @param deps - Dependencies that retrigger the effect; defaults to an empty list.
 * @param delay - Debounce window in milliseconds; defaults to 500.
 * @returns Nothing.
 */
const useDebounceEffect = (fnc: () => void, deps: unknown[] = [], delay = 500) => {
  const ref = useRef<ReturnType<typeof setTimeout>>();
  const isFirst = useRef(true);

  useEffect(() => {
    if (isFirst.current) {
      fnc();
      isFirst.current = false;
      ref.current = setTimeout(() => {
        isFirst.current = true;
      }, delay);
      return;
    }
    clearTimeout(ref.current);
    ref.current = setTimeout(() => {
      fnc();
      isFirst.current = true;
    }, delay);
  }, [...deps, delay]);
};

// const useDebounceEffect = (fnc, deps = [], delay = 500) => {
//   const ref = useRef();
//   useEffect(() => {
//     clearTimeout(ref.current);
//     ref.current = setTimeout(() => {
//       fnc();
//     }, delay);
//   }, [...deps, delay]);
// };

export default useDebounceEffect;
